<template>
<div class="bk-blue-light">
    <img src="../../../assets/images/pentru-imunitate/vitamina-A.png" style="width: 54px; height: 54px">
    <h2>Vitamina A</h2>
    <p>contribuie la funcționarea normală a sistemului imunitar. Se găsește în fructele și
        legumele
        colorate cum ar fi: morcovii, cartofii dulci, spanacul, mazărea, ardeiul gras,
        piersicile
        sau mango.</p>
</div>
</template>

<script>
export default {
    name: 'Vitamina-A',

    data() {
        return {

        }
    },
}
</script>
<style scoped lang="scss">
.bk-blue-light {
    background: #F2F0ED;
    border-radius: 20px;
    width: 458px !important;
    min-height: 270px;
    max-height: 270px;
    position: relative;

    @media only screen and (max-width: 992px) {
        width: 100% !important;
        min-height: 100%;
        max-height: 100%;
        margin-top: 15px;
    }

    &:focus {
        outline: none;
    }

    p {
        font-size: 14px;
        font-weight: 500;
        color: #029FE3;
    }

    span {
        font-size: 16px;
        font-weight: 500;
        color: #029FE3;
    }
}
@media only screen and (max-width: 526px) {
  .bk-blue-light img{
    width: 54px;
    margin-left: 0;
  }
  .bk-blue-light{
    text-align: left;
    width: 95% !important;
  }
}
</style>
